import { render, staticRenderFns } from "./svip.vue?vue&type=template&id=bcb4959c&scoped=true&"
import script from "./svip.vue?vue&type=script&lang=js&"
export * from "./svip.vue?vue&type=script&lang=js&"
import style0 from "./svip.vue?vue&type=style&index=0&id=bcb4959c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb4959c",
  null
  
)

export default component.exports